export default __webpack_public_path__ + "static/media/flag.1b1743f7.wav";